// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_lb-0";